import React, { useState, useEffect } from 'react';
import './App.css';
import textContents from './data/dataInterface';
import Loader from './components/Loader/Loader';
import StartPage from './components/StartPage/StartPage';
import NavbarGame from './components/NavbarGame/NavbarGame';
import InfoPage from './components/InfoPage/InfoPage';
import GamePage from './components/GamePage/GamePage';
import { setTimeout } from 'timers';

let langv = 'rus';
let imagesArr = {}; //массив с картинками, ключ - название картинки
let isLoad = false;
let num = 0;
let alphabetRus = [];
let alphabetFin = [];
let wordsRus = {};
let wordsFin = {};
let curPlace = [0,1, 2, 3, 4];

function arrayUnique(arr) {             //удалить повторяющиеся значения  массива
    return arr.filter((e, i, a) => a.indexOf(e) === i)
};

function GameWords(content) {
    let letter = '';
    let word = '';
    let words = [];
    Object.keys(content).forEach(function (key, id) {   //определение букв на которые есть слова
        word = content[key].rus;
        letter = word[0];
        alphabetRus.push(letter);
        word = content[key].fin;
        letter = word[0];
        alphabetFin.push(letter);
    });
    alphabetRus = arrayUnique(alphabetRus);
    alphabetFin = arrayUnique(alphabetFin);
 //массив слов в соединении с буквой и адресом картинки
    let id = 0;
    for (let i = 0; i < alphabetRus.length; i++) {
        words = [];
        id = 0;
        let curLetter = alphabetRus[i];
        Object.keys(content).forEach(function (key) {
            word = content[key].rus;

            if (word[0] === curLetter) {
                words.push({
                    place: id,
                    word: word,
                    key: key
                });
                id++;
            };
        });
        wordsRus[curLetter] = words;
    };
    
    for (let i = 0; i < alphabetFin.length; i++) {
        words = [];
        id = 0;
        let curLetter = alphabetFin[i];
        Object.keys(content).forEach(function (key) {
            word = content[key].fin;
            if (word[0] === curLetter) {
                words.push({
                    place: id,
                    word: word,
                    key: key
                });
                id++;
            }
        })
        wordsFin[curLetter] = words;
    };
    shuffle(alphabetRus);  //перемешиваем массив, в этом порядке будет идти текущая игра
    shuffle(alphabetFin);  
};

function GameContent(content, callback) {
    let imagesName = Object.keys(content);
    for (let id of imagesName) {                 //чтение в кэш картинок контента, ключ - название картинки
        let urlFile = process.env.PUBLIC_URL + '/content/' + id + '.png';
        imagesArr[id] = new Image(550, 315);
        imagesArr[id].src = urlFile;
    };
    imagesArr['bgStart'] = new Image(695, 594);
    imagesArr['bgStart'].src = process.env.PUBLIC_URL + '/interface/background.jpg';
    imagesArr['bgGame'] = new Image(695, 594);
    imagesArr['bgGame'].src = process.env.PUBLIC_URL + '/interface/backgroundSmall.png';
    GameWords(content);
   
    callback();
};

function readData() { //чтение данных 
    let address = window.top.document.location.href; //определение языка на котором находится игра
    if (address.indexOf('/fin/') > 0) langv = 'fin';

    GameContent(textContents.content, function () { isLoad = true; });
};

readData();

//Функции перемешивания масива

//вспомогательная функция
function putToCache(elem, cache) {
    if (cache.indexOf(elem) !== -1) {
        return;
    }
    var i = Math.floor(Math.random() * (cache.length + 1));
    cache.splice(i, 0, elem);
}
//функция, возвращающая свеженький, девственный компаратор
function madness() {
    var cache = [];
    return function (a, b) {
        putToCache(a, cache);
        putToCache(b, cache);
        return cache.indexOf(b) - cache.indexOf(a);
    };
}
//собственно функция перемешивания
function shuffle(arr) {
    var compare = madness();
    return arr.sort(compare);
};


function App() {
    const [isLoading, setIsLoading] = useState(false);  //окно1,признак загрузки контента
    const [isStart, setIsStart] = useState(false);      //окно2,начало игры с нуля, выбор языка
    const [isInfo, setIsInfo] = useState(false);        //окно3, инструкция к игре
    const [isNavbar, setIsNavbar] = useState(false);	//окно4, верхнее меню
    const [isGame, setIsGame] = useState(false);		//окно5, слова - буквы


    const [lang, setLang] = useState(langv);
    const [curAlphabet, setCurAlphabet] = useState(' ');
    const [curAllWords, setCurAllWords] = useState(' ');
    const [curWords, setCurWords] = useState(' ');
    const [dopWords, setDopWords] = useState(' ');
    const [curLetter, setCurLetter] = useState(' ');

    const [step, setStep] = useState(0);
    const [disabled, setDisabled] = useState(true);  // правильный ответ нажат, окна с вопросами не видны ???

    const preloadTime = (() => {
        for (let i = 0; i < 4; i++) {
            if (num > 0) break;
            if (isLoad && num === 0) {
                setIsLoading(isLoad);
                setCurAlphabet(alphabetRus);
                setCurAllWords(wordsRus);
                shuffle(curPlace);
                let arr = wordsRus[alphabetRus[0]].slice(0, 5);
                for (let i = 0; i < arr.length; i++) arr[i].place = curPlace[i];
                setCurWords(arr);
                setDopWords(wordsRus[alphabetRus[0]].slice(5));
                setCurLetter(alphabetRus[0]);
                setIsStart(true);
                num++;
                break;
            }
            setTimeout(setIsLoading, 2000, isLoad);
        }
    });
    useEffect(() => {
        setTimeout(preloadTime, 3000);
    }, [isLoading]);

    function newLetter(numStep, callback) {
        shuffle(curPlace);
        setStep(numStep);
        setDisabled(true);
        callback();
    }
    function PlaceWords() {
        let arr = curAllWords[curAlphabet[step]].slice(0, 5);
        for (let i = 0; i < arr.length; i++) arr[i].place = curPlace[i];
        setCurWords(arr);
        setDopWords(curAllWords[curAlphabet[step]].slice(5));
        setCurLetter(curAlphabet[step]);
    }

    const handleComponent = ((pri,place,index) => {
    if (pri === 'rus' && lang === 'fin') {
        setLang('rus');
        langv = pri;
        setDisabled(true);
        shuffle(alphabetRus);
        setCurAlphabet(alphabetRus);
        setCurAllWords(wordsRus);
        setCurWords(wordsRus[alphabetRus[0]].slice(0, 5));
        setDopWords(wordsRus[alphabetRus[0]].slice(5));
        setCurLetter(alphabetRus[0]);
        if (isGame) {
            setIsGame(false);
            setIsStart(true);
            setIsNavbar(false);
        };
        };
        if (pri === 'fin' && lang === 'rus') {
            setLang('fin');
            langv = pri;
            setDisabled(true);
            shuffle(alphabetFin);
            setCurAlphabet(alphabetFin);
            setCurAllWords(wordsFin);
            setCurWords(wordsFin[alphabetFin[0]].slice(0, 5));
            setDopWords(wordsFin[alphabetFin[0]].slice(5));
            setCurLetter(alphabetFin[0]);
            if (isGame) {
                setIsGame(false);
                setIsStart(true);
                setIsNavbar(false);
            };
        }
        if (pri === 'start') {
            shuffle(alphabetRus);
            shuffle(alphabetFin);

            setIsStart(false);
            setIsInfo(true);
            setIsNavbar(true);
            setStep(0);
        }
         if (pri === 'continue') {
            setIsInfo(false);
            setIsGame(true);
        };
       
        if (pri === 'info') {
            setIsInfo(true);
            setDisabled(true);
            setIsGame(false);

        };
        if (pri === 'toStart') {
            shuffle(curAlphabet);
            setIsStart(true);
            setIsGame(false);
            setIsInfo(false);
            setIsNavbar(false);
            newLetter(0, PlaceWords);
          }
        if (pri === 'prev') {
            if (step === 0) {    //игра идёт по кругу
                let lastStep = curAlphabet.length - 1;
                newLetter(lastStep, PlaceWords);
            }
            else {
                newLetter((step - 1), PlaceWords);
            }
        }
        if (pri === 'next') {       //игра идёт по кругу
            if (step === (curAlphabet.length - 1)) {
                newLetter(0, PlaceWords);
            }
            else {
                newLetter((step + 1), PlaceWords);
            }
        }
               
        if (pri === 'downImg') {
            setDisabled(false);
            let arr = curWords;
            let array = dopWords;
            if (dopWords.length > 0) {
                arr.push({
                    place: place,
                    word: array[0].word,
                    key: array[0].key
                });
                array.splice(0,1);
            }
            arr.splice(index, 1);
            setCurWords(arr);
            setDopWords(array);
            if (arr.length === 0) setTimeout(() => { handleComponent('next'); }, 3000);
        }

    });

  return (
      <div className='App'>
          {!isLoading ? <Loader /> : null}
          {isStart ? (<StartPage lang={lang} onClick={(pri) => handleComponent(pri)} startPage={textContents.startPage} src={imagesArr['bgStart'].src}/>) : null}
          {isNavbar ? <NavbarGame lang={lang} onClick={(pri) => handleComponent(pri)} topMenu={textContents.topMenu} src={imagesArr['bgGame'].src} /> : null}
          {isInfo ? <InfoPage lang={lang} onClick={(pri) => handleComponent(pri)} textGame={textContents.textGame}  /> : null}
          {isGame ? <GamePage step={step} disabled={disabled}  curWords={curWords} letter={curLetter} imagesArr={imagesArr} fontStyle={textContents.fontAllAlphabet[lang][curLetter]} onClick={(pri, place, index) => handleComponent(pri, place, index)} imgNew='' /> : null}

      </div>

  );
}

export default App;